export interface IAlrBaseConstParam {
    resultCode?:string
    datStr?:string
}

export class AlrBase {    

    public resultCode:ApiResultCode
    public datStr:Date
    
    constructor({resultCode='',datStr=''}:IAlrBaseConstParam = {}) {        
        this.resultCode = resultCode as ApiResultCode
        this.datStr = new Date(datStr)
    }
}

export enum ApiResultCode {
    Ok							= 'Ok',

    ResultCodeNotProvided		= 'ResultCodeNotProvided',
    FileNotFound				= 'FileNotFound',

    UnauhtorizedUser			= 'UnauhtorizedUser',		// L'utilisateur n'est pas authentifié (mal fichu: AuthorizedAttribute ne renvoie que ça)
    AccessForbidden				= 'AccessForbidden',		// L'utilisateur est authentifié mais il n'a pas le droit d'accéder à la ressource demandée
    UnauthorizedMethod			= 'UnauthorizedMethod',
    

    InvalidModelState			= 'InvalidModelState',
    ApirisNoSuccess				= 'ApirisNoSuccess',
    ApirisNoBody				= 'ApirisNoBody',
    ApirisTimeout				= 'ApirisTimeout',
    ApirisConnectionRefused		= 'ApirisConnectionRefused',
    ApirisUnableToDeserialize	= 'ApirisUnableToDeserialize',
    ApirisSocketError			= 'ApirisSocketError',

    InternalException			= 'InternalException',
}